import ElDropdown from './src/dropdown';

/* istanbul ignore next */
ElDropdown.install = function(Vue) {
  Vue.component(ElDropdown.name, ElDropdown);
};

export default ElDropdown;



// WEBPACK FOOTER //
// ./src/components/element/packages/dropdown/index.js